import { atom } from "recoil";

export const advancedSearch = atom({
  key: "advanced-search",
  default: {
    IdResponsible: "",
    IdIdCities: "",
    RankingCustomer: "",
    methodOfIntroduction: "",
    KindCustomer: "",
    KindSeller: "",
    IdMarketer: "",
    ProbabilityOfPurchase: "",
    NameCategory: "",
    BrandCategory: "",
    Start: "",
    End: "",
  },
});
